import type { VisualMatch as VisualMatchType } from '@frameio/graphql-client/generated';
import type { useSetAssetClipMatch } from '../../hooks';

type PrepareAssetClipMatchProps = {
  assetId: string;
  visualMatch: VisualMatchType;
  activeClipIndex: number;
  setAssetClipMatch?: ReturnType<typeof useSetAssetClipMatch>;
};

/** Sets up the asset clip match active index and
 * returns the current time (microseconds) and duration (seconds) of the clip
 * for deeplinking to viewer (see packages/shared/routing/pages/folderViewer.ts) */
export const prepareAssetClipMatch = ({
  assetId,
  visualMatch,
  activeClipIndex,
  setAssetClipMatch,
}: PrepareAssetClipMatchProps) => {
  setAssetClipMatch?.(assetId, visualMatch, activeClipIndex);
  const clipStartTime = visualMatch.clips?.[activeClipIndex]?.startTime ?? 0;
  const clipEndTime = visualMatch.clips?.[activeClipIndex]?.endTime ?? 0;

  const currentTime = clipStartTime * 1000;
  const duration = (clipEndTime - clipStartTime) / 1000;

  return {
    currentTime,
    duration,
  };
};
